export enum PreferencesOptionsEnum {
  GROUP_CATALOG = 'ikcloud_12857_is_product_tab_visible_for_group_admin',
  IKCLOUD_40826_DATASYS_VOUCHER = 'ikcloud_40826_datasys_voucher',
}
